export const CREATE_NEW_FACILITATOR_MAKE = () => `facilitator/createNewMake`;
export const GET_ALL_FACILITATOR_MAKES = () => `facilitator/getAllMakes`;
export const GET_FACILITATOR_MAKE_BY_ID = (makeId) => `facilitator/make/${makeId}`;
export const DELETE_FACILITATOR_MAKE = (makeId) => `facilitator/make/${makeId}/delete`;
export const UPDATE_FACILITATOR_MAKE = (makeId) => `facilitator/make/${makeId}/update`;
